/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Header_Create_TenantInputs */

const es_user_profile_header_create_tenant = /** @type {(inputs: User_Profile_Header_Create_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nueva empresa`)
};

const en_user_profile_header_create_tenant = /** @type {(inputs: User_Profile_Header_Create_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new organization`)
};

/**
* | output |
* | --- |
* | "Create new organization" |
*
* @param {User_Profile_Header_Create_TenantInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_header_create_tenant = /** @type {((inputs?: User_Profile_Header_Create_TenantInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Header_Create_TenantInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_header_create_tenant(inputs)
	return en_user_profile_header_create_tenant(inputs)
});
export { user_profile_header_create_tenant as "user.profile.header.create_tenant" }